import { useCallback, useEffect, useState } from "react";

import { getRemoteConfig } from "/util/countly";
import { SystemMessage } from "/util/countly/types";

let wasClosed = false;

const useSystemMessage = () => {
  const [systemMessage, setSystemMessage] = useState<SystemMessage | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const remoteConfig = getRemoteConfig();
    const value = remoteConfig.summit_feature_system_message;

    if (value && value.isEnabled && value.message && !wasClosed) {
      setSystemMessage(value);
      setIsOpen(true);
    }
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    wasClosed = true;
  }, []);

  return {
    close,
    isOpen,
    message: systemMessage?.message ?? "",
    link: systemMessage?.link,
    linkText: systemMessage?.linkText,
    dismissable: systemMessage?.dismissable ?? true,
  };
};

export default useSystemMessage;
